import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["orderSelect"]

  updateUrl(event) {
    const orderId = this.orderSelectTarget.value

    if (!orderId) {
      event.preventDefault()
      return
    }

    this.element.action = `/orders/${orderId}/claims/select_shipment`
  }
}
